module.exports = __webpack_public_path__ + "img/icon_whatsapp.bc638533.svg";